import { useStytch, useStytchUser, useStytchSession } from "@stytch/react";

export { useStytch, useStytchUser, useStytchSession };

/**
 * Whether the SDK has finished deciding who, if anyone, is signed in.
 *
 * On web the user hydrates asynchronously, so `patientId` — read off the user's
 * trusted metadata — is undefined for the first renders after a page load, and
 * every query gated on it is disabled rather than loading. Anything that would
 * otherwise read "disabled and empty" as "settled and empty" needs this.
 */
export function useIsAuthReady(): boolean {
  const { isInitialized } = useStytchUser<false>();
  return isInitialized;
}
